import { takeLatest, put, all, call } from 'redux-saga/effects';
import AuthActionType from './auth.types';
import { authLogin } from './auth.services';
import type { AuthLoginOutcome, Credentials } from './auth.services';
import { authLoginSuccess, authLoginFailure, authLoginChanged } from './auth.action';
import { setRole } from '../session/session.action';
import { toApiError } from '../_common/apiClient';

function* authLoginAsync({ payload }: { type: string; payload: Credentials }): Generator {
  try {
    const outcome = (yield call(authLogin, payload)) as AuthLoginOutcome;
    yield put(
      authLoginSuccess({
        role: outcome.role,
        accessToken: outcome.accessToken,
        refreshToken: outcome.refreshToken,
        user: outcome.user,
        mustChangePassword: outcome.mustChangePassword === true,
      }),
    );
    // Keep the existing client-side role → modules logic: set session.roleId.
    yield put(setRole(outcome.role.id));
  } catch (error) {
    // The code travels too: a 429 is a wait, not a wrong password, and the
    // screen used to paint both the same red.
    yield put(authLoginFailure({ message: toApiError(error).message, code: toApiError(error).code }));
  }
}

function* authLoginReset(): Generator {
  yield put(authLoginChanged());
}

export function* onAuthLoginStart(): Generator {
  yield takeLatest(AuthActionType.AUTH_LOGIN_START, authLoginAsync);
}
export function* onAuthLoginReset(): Generator {
  yield takeLatest(AuthActionType.AUTH_LOGIN_RESET, authLoginReset);
}

export function* authSaga(): Generator {
  yield all([call(onAuthLoginStart), call(onAuthLoginReset)]);
}
